__turbopack_context__.v({
  "filter": "V53oNq_filter",
  "grid": "V53oNq_grid",
  "jobs": "V53oNq_jobs",
  "location": "V53oNq_location",
  "refine-search": "V53oNq_refine-search",
  "sidebar": "V53oNq_sidebar",
  "title": "V53oNq_title",
});
